// extracted by mini-css-extract-plugin
export var allPaneContainer = "FJ4hV";
export var bizChatInReadingPaneStyles = "ywxLz";
export var bleedthroughBackgroundDark = "Tbbce";
export var bleedthroughBackgroundLight = "u7yLj";
export var cardAndMLWrapper = "rRhzD";
export var cardAndMLWrapperBizChatSpacing = "ILLxa";
export var denselessCompose = "WqnPt";
export var denselessComposeBleedthrough = "m4AX5";
export var denselessComposeBleedthroughNoLeftBorder = "ZPL03";
export var denselessComposeInnerNeutral = "lKvAc";
export var denselessComposeInnerNeutralLeftBorderRounded = "BPXEi";
export var denselessComposeInnerSearch = "xjFA8";
export var fullBleed = "WKBCQ";
export var innerPaneContent = "SW7A6";
export var leftColumn = "YYA9V";
export var leftColumnBleedThrough = "GciPK";
export var leftColumnDenseless = "rB0Kn";
export var leftColumnDenselessRtl = "cR4_k";
export var leftColumnRtl = "THOoJ";
export var leftPaneContainer = "Yd48r";
export var leftPanelSecondRow = "kTUsm";
export var leftResizeHandler = "lKhXQ";
export var mailListCardContainerWithRPHiddenOrBottom = "e8s8U";
export var mailListCardContainerWithRPHiddenOrBottomDenseless = "nC1E4";
export var mailListCardContainerWithRPHiddenOrBottomDenselessNeutral = "Fgjvj";
export var mailListComposeRightBorderDenseless = "eiEgp";
export var mailListHide = "c_ifE";
export var mailListLeftPaneVisibleFullBleed = "hmUtu";
export var mailListLeftPaneVisibleFullBleedDenseless = "Varvg";
export var mailListLeftPaneVisibleFullBleedDenselessLeftBorderRounded = "EBbuI";
export var mailListLeftPaneVisibleFullBleedDenselessLeftBorderRoundedRtl = "ffRXk";
export var mailListLeftPaneVisibleFullBleedDenselessNoTopMargin = "NKdSz";
export var mailListLeftPaneVisibleFullBleedDenselessRightBorderRounded = "qX6hl";
export var mailListLeftPaneVisibleFullBleedDenselessRightBorderRoundedRtl = "Y0SDi";
export var mailListNeutralBorder = "LN4JE";
export var mailListNeutralTopBorder = "NFjsn";
export var mailListRefresh = "LyMTI";
export var mailListRefreshNoLeftBorder = "PESTR";
export var mailListRefreshNoLeftBorderRtl = "G8ArK";
export var mailListRefreshRtl = "N_du_";
export var mailListWithRPHiddenOrBottom = "XW2m0";
export var mailListWithRPHiddenOrBottomDenseless = "QW7vs";
export var mailListWithRPHiddenOrBottomDenselessNeutral = "VvlZl";
export var mailListWithRPRight = "C1EJK";
export var mailListWithRPRightDenseless = "DtGia";
export var mailMain = "I3sS5";
export var newBackgroundOpacity = "DjZo8";
export var newSearchHeaderContainer = "Dt4E5";
export var newSearchHeaderContainerMargin = "SCAqn";
export var notificationBarHostElevated = "lRcJs";
export var panes = "LBktY";
export var positionRelative = "U5nOs";
export var protocolNotSupportedContainer = "dbelr";
export var readingPane = "Mq3cC";
export var resizeHandle = "wzILN";
export var rightPane = "HOVUa";
export var rightPaneContainer = "q9iRC";
export var rightPaneDenseless = "LbVEN";
export var rightPaneWithRail = "fyyXL";
export var rightPaneWithRailContent = "PAPWc";
export var searchHeaderBorders = "brBxj";
export var searchHeaderBordersBleedThrough = "cdsXY";
export var searchHeaderBordersBleedThroughNoBorder = "LjYbv";
export var searchHeaderBordersBleedThroughNoBorderNoBlur = "AkvXz";
export var searchHeaderBordersDark = "kETEC";
export var searchHeaderBordersLight = "FdUPY";
export var searchHeaderBordersNeutral = "aYnwr";
export var searchHeaderLeftBordersBleedThrough = "BoMGI";
export var searchNeutralLeftMargin = "_REkq";
export var searchResultsContainer = "PsJx7";
export var searchResultsContainerBorder = "rEGzK";
export var searchResultsTabbedContainer = "RhuSi";
export var searchResultsTabbedContainerDenseless = "LPfdH";
export var subCommandBarPaneColumn = "G8_Dc";
export var subCommandBarPaneCommon = "FkPdL";
export var subCommandBarPaneCommonRefresh = "czwRD";
export var subCommandBarPaneMail = "LCprM";
export var subCommandBarPaneRow = "nbmyu";